import { qs } from "url-parse";

export function saveToken(token) {
  window.localStorage.setItem("token", token);
}

export function getToken() {
  return window.localStorage.getItem("token") || "";
}

export function authenticate() {
  const params = qs.parse(window.location.search);

  if (params.token) {
    saveToken(params.token);
  }
}
